module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uFm966Hj7iYbq2KensB5yj6"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("The rain had stopped. The afternoon sun had resumed its assault on rotting corn shocks, casting distorted shadows across the abandoned farm. A pair of cicadas sounded, silencing the chirping of the nearby sparrows, sending them into flight.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("In the middle of the field, a sturdy youth stood silently, eyes fixed on a mound of fresh clay.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("A rush of cool air stirred wisps of his ripened-wheat-colored hair. Bending down, he used a finger to inscribe the name ‘Gus’ in the collected soil.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("A second youth, a female, approached. “Can we go now,” she asked, wearily. “This is our tenth field and there’s nothing left of him to bury.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“In a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The girl looked around. “Someone could be watching, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Just need a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Well, you’d better make it a quick one.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The youth’s eyes lingered on the newly formed grave. With a nod of satisfaction, he uprighted himself. As a smile lit his face, he used the heel of his boot to eradicate their victim’s name. “Lovee,” he said, “may the bastard rest in peace.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“You mean in pieces. Let’s go.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5fa9e32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Prologue.vue
// module id = 75
// module chunks = 0